import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect } from 'react';
import { useTranslation } from '@aviv-unified-frontend/runtime/i18n';
import { Box } from '@gemini/core';
import { Button } from '@gemini/ui';
import { MFE_IDENTIFIER } from '@price-pages-agency-cards/src/constants';
import { GERMAN_PROFILE_ANCHOR, mediums } from '@price-pages-agency-cards/src/constants/tracking';
import { EventPlace } from '@shared-utils/domain/event.entity';
import { getAgencyProximity } from '@shared-utils/helpers/cardDisplay';
import { isPlural } from '@shared-utils/helpers/lokalise';
import { dispatchStatsEvent } from '@shared-utils/helpers/statsEvent';
import { InternalEventType } from '@shared-utils/helpers/statsEvent/statsEvent.type';
import { generateAVItemPricePages } from '@shared-utils/helpers/tracking';
import { useBreakpoint } from '@shared-utils/helpers/viewport';
import { AV_LINK_TEXT, AV_LIST_NAME, AV_ZONE, TRACKING_EVENT_TYPE, } from '@shared-utils/types/analytics.types';
import Address from '@shared-utils/ui/components/Address';
import Logo from '@shared-utils/ui/components/Logo';
import PropertiesForSale from '@shared-utils/ui/components/PropertiesForSale';
import Rating from '@shared-utils/ui/components/Rating';
import Seniority from '@shared-utils/ui/components/Seniority';
import { sendAnalytics } from '../../helpers/tracking';
const onClickTrackingEvent = (avItem, agency, itemClicked, lastZipCode) => {
    sendAnalytics({
        av_geolocation_level: '%av_geolocation_level%',
        av_items: avItem,
        av_zone: AV_ZONE.PRICE_SIDE_PANEL,
        event: TRACKING_EVENT_TYPE.SELECT_ITEM,
        link_text: itemClicked,
    });
    dispatchStatsEvent({
        payload: {
            lastUserSearch: lastZipCode,
            legacyBrandId: agency.id,
            name: agency.agencyName,
            place: EventPlace.PRICE_PAGES,
            zipCode: agency.address.zipCode,
        },
        type: InternalEventType.REDIRECTED,
    });
};
const SidePanelCard = ({ agency, index, nbOfAgencies, lastZipCode, }) => {
    const { t } = useTranslation(MFE_IDENTIFIER);
    const { isMobile } = useBreakpoint();
    useEffect(() => {
        dispatchStatsEvent({
            payload: {
                lastUserSearch: lastZipCode,
                legacyBrandId: agency.id,
                name: agency.agencyName,
                place: EventPlace.PRICE_PAGES,
                zipCode: agency.address.zipCode,
            },
            type: InternalEventType.CONTAINED,
        });
    }, []);
    const { agencyLogo, agencyName, profileUrl, address: { zipCode, city }, reviews, propertiesForSale, seniority, distance, } = agency;
    const propertiesForSaleTranslations = {
        noProperties: t('wlac_no_propforsale'),
        properties: t(`wlac_nb_propforsale.${isPlural(propertiesForSale)}`, {
            count: propertiesForSale,
        }),
    };
    const { mediumContact, mediumLogo } = mediums;
    const avItem = [
        generateAVItemPricePages(agency, AV_LIST_NAME.PRICE_MAP_RECOMMENDED_AGENCY_SIDE, index),
    ];
    return (_jsxs(Box, { alignItems: "center", backgroundColor: "color.background.default", borderBottomStyle: index === nbOfAgencies - 1 ? 'solid' : 'none', borderColor: "color.background.subdued", borderTopStyle: "solid", borderWidth: "borderWidth.1", columnGap: "spacing.16", display: "grid", gridTemplateColumns: "auto 1fr", paddingVertical: "spacing.16", rowGap: "spacing.24", width: "100%", children: [_jsx(Logo, { agencyLogo: agencyLogo, agencyName: agencyName, linkUrl: `${profileUrl}${mediumLogo}${GERMAN_PROFILE_ANCHOR}`, onClick: () => onClickTrackingEvent(avItem, agency, AV_LINK_TEXT.LOGO, lastZipCode) }), _jsxs(Box, { display: "flex", flexDirection: "column", gap: "spacing.8", gridColumn: "2", children: [_jsxs(Box, { display: "flex", flexWrap: "nowrap", justifyContent: "space-between", children: [_jsx(Box, { typography: "typography.body.16.bold", children: agencyName }), seniority && (_jsx(Box, { children: _jsx(Seniority, { startYear: seniority, t: t }) }))] }), _jsx(Address, { city: city, distance: distance, zipCode: zipCode, content: distance
                            ? t('wlac_proximity', {
                                replace: { proximity: getAgencyProximity(distance) },
                            })
                            : undefined, isGreyContent: true }), _jsxs(Box, { display: "flex", flexDirection: isMobile ? 'column' : 'row', gap: "spacing.8", children: [reviews && (_jsx(Rating, { reviews: {
                                    avgRating: reviews?.avgRating,
                                } })), _jsx(PropertiesForSale, { content: propertiesForSaleTranslations, propertiesCount: propertiesForSale })] })] }), _jsx(Box, { gridColumn: "1 / -1", children: _jsx(Button, { href: `${profileUrl}${mediumContact}${GERMAN_PROFILE_ANCHOR}`, size: "40", variant: "secondary", isExternal: true, isFullWidth: true, onPress: () => onClickTrackingEvent(avItem, agency, AV_LINK_TEXT.CONTACT_CTA, lastZipCode), children: t('wlac_primarycta') }) })] }, agency.id));
};
export default SidePanelCard;
